type DBRole = "super_admin" | "super_super_admin" | "system_admin" | "viewer";

export const usePermissions = () => {
  const storedUser = (() => {
    try { return JSON.parse(localStorage.getItem("user") || "{}"); }
    catch { return {}; }
  })();

  const role = (storedUser?.role ?? "viewer") as DBRole;

  return {
    role,
    isViewer:             role === "viewer",
    isSuperAdmin:         role === "super_admin",
    isSuperSuperAdmin:    role === "super_super_admin",
    isSystemAdmin:        role === "system_admin",
    canManage:            role === "system_admin",
    canViewLogs:          role === "system_admin" || role === "super_super_admin",
    canAccessUserMgmt:    role === "system_admin",
    canAccessFeatureCtrl: role === "system_admin",
  };
};